import api from "@/apis/system/layoutAPI";
import Crud from "./crudBase";
var crud = new Crud("layout", api);

const state = {
   ...crud.state,
   _config: {
    field: {
	    key: "id",
      name: "name"
    }
  },
  /**
   * Mẫu áp dụng
   */
  apply: {

  }
};
const getters = {
  ...crud.getters,
  apply: function(state) {
    return state.aplly;
  }
};
const actions = {
  ...crud.actions,
  async loadApply(context, payload) {
    context.commit("updateLoading", true);

    let res = await api.getApply(payload);
    context.commit("updateLoading", false);

    if (res) {
      context.commit("updateApply", {
         tag: payload,
         layout: res
      });
    }
    
    return res;
  },

  async loadApplyDefault(context, payload) {
    context.commit("updateLoading", true);

    let res = await api.getDefault(payload);
    context.commit("updateLoading", false);
    
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  updateApply(state, res) {
     if (res.tag && res.layout) {
        state.apply[res.tag] = res.layout;
     }
  }
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
